import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from '../common/app';
/**
 * The `Session` class defines the current user session. It stores a reference
 * to the current authenticated user, and provides methods to log in/out.
 */
export default class Session {
  constructor(user, csrfToken) {
    /**
     * The current authenticated user.
     */
    _defineProperty(this, "user", void 0);
    /**
     * The CSRF token.
     */
    _defineProperty(this, "csrfToken", void 0);
    this.user = user;
    this.csrfToken = csrfToken;
  }

  /**
   * Attempt to log in a user.
   */
  login(body, options) {
    if (options === void 0) {
      options = {};
    }
    return app.request(_objectSpread({
      method: 'POST',
      url: "".concat(app.forum.attribute('baseUrl'), "/login"),
      body
    }, options));
  }

  /**
   * Log the user out.
   */
  logout() {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = "".concat(app.forum.attribute('baseUrl'), "/logout");
    const tokenField = document.createElement('input');
    tokenField.type = 'hidden';
    tokenField.name = 'csrfToken';
    tokenField.value = this.csrfToken;
    form.appendChild(tokenField);
    document.body.appendChild(form);
    form.submit();
  }
}
flarum.reg.add('core', 'common/Session', Session);